<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 子服务商
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <!-- <el-select v-model="query.address" placeholder="地址" class="handle-select mr10">
                    <el-option key="1" label="广东省" value="广东省"></el-option>
                    <el-option key="2" label="湖南省" value="湖南省"></el-option>
                </el-select> -->
                <el-input v-model="query.company_account" placeholder="账号" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                <el-button type="primary" @click="reset">重置</el-button>
            </div>
            <el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
                @selection-change="handleSelectionChange" v-loading="loading">
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
                
                <el-table-column prop="company_account" label="账号"></el-table-column>
                <el-table-column prop="company_password" label="密码" ></el-table-column>
                <el-table-column prop="company_mid" label="商户号"></el-table-column>
                <el-table-column prop="distribute" label="主服务费用（%）">
                    <template slot-scope="scope">
                       <span>微信:{{scope.row.distribute}} 支付宝:{{scope.row.trade_distribute}} 云闪付:{{scope.row.acp_distribute}}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="账户余额">
                    <template slot-scope="scope">￥{{scope.row.money}}</template>
                </el-table-column> -->
                <!-- <el-table-column label="头像(查看大图)" align="center">
                    <template slot-scope="scope">
                        <el-image
                            class="table-td-thumb"
                            :src="scope.row.thumb"
                            :preview-src-list="[scope.row.thumb]"
                        ></el-image>
                    </template>
                </el-table-column> -->
                <!-- <el-table-column prop="date" label="注册时间"></el-table-column> -->
                <el-table-column label="操作" width="250" align="center"> 
                    <template slot-scope="scope">
                        <!-- <el-button @click="goMerchant(scope.$index, scope.row)">管理</el-button> -->
                        <el-button type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">编辑
                        </el-button>
                        <el-button type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">删除
                        </el-button>
                        <!-- <el-button type=""></el-button>> -->
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination background layout="total, prev, pager, next" :current-page="query.query"
                    :page-size="query.limit" :total="pageTotal" @current-change="handlePageChange"></el-pagination>
            </div>
        </div>

        <!-- 添加弹出框 -->
        <el-dialog title="编辑子服务商户" :visible.sync="editVisible" width="500px">
            <el-form label-width="130px" :model="editform" ref="editform" :rules="rules">
                <el-form-item label="账号:" prop="company_account">
                    <el-input class="w400" v-model="editform.company_account"></el-input>
                </el-form-item>
                <el-form-item label="密码:" prop="company_password">
                    <el-input class="w400" v-model="editform.company_password"></el-input>
                </el-form-item>
                <el-form-item label="商户号:" prop="company_mid">
                    <el-input class="w400" v-model="editform.company_mid"></el-input>
                </el-form-item>
                <el-form-item label="主服务商微信服务费(%):" prop="distribute" >
                    <el-input class="w400" v-model="editform.distribute" ></el-input>
                </el-form-item>
                <el-form-item label="主服务商支付宝服务费(%):" prop="trade_distribute" >
                    <el-input class="w400" v-model="editform.trade_distribute" ></el-input>
                </el-form-item>
                <el-form-item label="主服务商云闪付服务费(%):" prop="acp_distribute" >
                    <el-input class="w400" v-model="editform.acp_distribute" ></el-input>
                </el-form-item>
                <el-form-item label="绑定主服务商:" prop="superior" >
                    <el-input class="w400" v-model="editform.superior" ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="upMerchant()">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    import QRCode from 'qrcodejs2'
    import {
        fetchData
    } from '../../api/index';
    const validateMoney = (rule, value, callback) => {
        if (!value) {
            callback(new Error('请输入'))
        } else if (value.indexOf(".") != -1 && value.split('.').length > 2) {
            callback(new Error('请输入正确格式的金额')) //防止输入多个小数点
        } else if (value.indexOf(".") != -1 && value.split('.')[1].length > 2) {
            callback(new Error('请输入正确的小数位数')) //小数点后两位
        } else {
            callback();
        }
    };
    export default {
        name: 'basetable',
        data() {
            return {
                addLoading: false,
                addVisible: false,
                qrcodeVisible: false,
                loading: true,
                query: {
                    id: '',
                    auth: '3',
                    limit: 8,
                    page: 1,
                    company_account: ''
                },
                tableData: [],
                multipleSelection: [],
                delList: [],
                editVisible: false,
                pageTotal: 0,
                form: {
                    company_account: '',
                    company_password: '',
                    company_mid: '',
                    distribute: '',
                    auth: 2,
                },
                editform: {},
                idx: -1,
                id: -1,
                rules: {
                    company_name: [{
                        required: true,
                        message: '请输入商户名称',
                        trigger: 'change'
                    }, ],
                    company_account: [{
                        required: true,
                        message: '请输入账号',
                        trigger: 'blur'
                    }, ],
                    company_password: [{
                            required: true,
                            message: '请输入密码',
                            trigger: 'change'
                        },
                        {
                            min: 6,
                            max: 18,
                            message: '长度在 6 到 18 个字符',
                            trigger: 'blur'
                        }
                    ],
                    company_mid: [{
                        required: true,
                        message: '请输入商户号',
                        trigger: 'blur'
                    }, ],
                    main_distribute: [{
                        type: 'string',
                        required: true,
                        trigger: 'blur',
                        validator: validateMoney
                    }, ],
                    main_trade_distribute: [{
                        type: 'string',
                        required: true,
                        trigger: 'blur',
                        validator: validateMoney
                    }, ],
                    main_acp_distribute: [{
                        type: 'string',
                        required: true,
                        trigger: 'blur',
                        validator: validateMoney
                    }, ],
                },
                voiceVisible:false,    //控制语音播报是否显示
                voicefrom:{},    //保存语音播报的input
                rules111:{         //验证规则
                    sn:[{
                        type:'number',
                        message:'请输入sn号，必须是数字',
                        required:true,
                    }],
                    token:[{
                        type:'string',
                        message:'请输入token',
                        required:true,
                    }],
                    version:[{
                        type:'number',
                        message:'请输入version，必须是数字',
                        required:true,
                    }]
                }
            };
        },
        created() {
            this.getData()
        },
        activated() {
            this.getData()
        },
        methods: {
            reset() {
                this.$set(this.query, 'page', 1);
                this.query.company_account = '';
                this.getData()
            },
            // 获取 easy-mock 的模拟数据
            getData() {
                let that = this
                let url = that.$apiUrl.merchant.getService
                that.$post(url, that.$params(that.query)).then(res => {
                    if (res.data.code == 200) {
                        that.loading = false
                        that.pageTotal = res.data.data.count
                        delete res.data.data.count;
                        that.tableData = res.data.data.list
                    }
                }).catch(error => {
                    that.loading = false
                    this.$message.error(error)
                })
            },
            closeCode() {
                this.$refs.qrCodeUrl.innerHTML = ''
            },
            // 触发搜索按钮
            handleSearch() {
                this.$set(this.query, 'page', 1);
                this.getData();
            },
            // 删除操作
            handleDelete(index, row) {
                let that = this
                // 二次确认删除
                this.$confirm('确定要删除吗？', '提示', {
                        type: 'warning'
                    })
                    .then(() => {
                        let url = that.$apiUrl.merchant.dleService
                        let query = {
                            id: row.id
                        }
                        that.$post(url, that.$params(query)).then(res => {
                            console.log(res)
                            if (res.data.code == 200) {
                                that.getData()
                                that.$message.success("删除成功")
                            }
                        }).catch(error => {
                            this.$message.error(error)
                        })
                    })
                    .catch(() => {});
            },
            creatQrCode(params) {
                var qrcode = new QRCode(this.$refs.qrCodeUrl, {
                    text: 'https://ym.huayetech.cn/index.php/page#/?id=' + params, // 需要转换为二维码的内容
                    width: 200,
                    height: 200,
                    colorDark: '#000000',
                    colorLight: '#ffffff',
                    correctLevel: QRCode.CorrectLevel.H
                })
                console.log(params)
            },
            downLoad() {
                let myCanvas = document.getElementById('qrcode').getElementsByTagName('canvas');
                let a = document.createElement('a')
                a.href = myCanvas[0].toDataURL('image/png');
                a.download = '二维码';
                a.click()
                this.$message({
                    message: "正在进行下载保存",
                    type: 'success'
                })
            },
            // 多选操作
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            delAllSelection() {
                const length = this.multipleSelection.length;
                let str = '';
                this.delList = this.delList.concat(this.multipleSelection);
                for (let i = 0; i < length; i++) {
                    str += this.multipleSelection[i].name + ' ';
                }
                this.$message.error(`删除了${str}`);
                this.multipleSelection = [];
            },
            addMerchant() {
                let that = this
                if (!that.addLoading) {
                    that.$refs['form'].validate((valid) => {
                        if (valid) {
                            that.addLoading = !that.addLoading
                            let url = that.$apiUrl.merchant.addService
                            that.$post(url, that.$params(that.form)).then(res => {
                                that.addLoading = false
                                if (res.data.msg == "添加失败" ||res.data.msg =='服务商重复' ||res.data.msg == "服务费错误" || res.data.msg == "服务商错误") {
                                    this.$message.error(res.data.msg)
                                } else if (res.data.msg == "添加成功") {
                                    that.$refs['form'].resetFields()
                                    that.addVisible = false
                                    that.getData()
                                    this.$message.success("添加成功")
                                }
                            }).catch(error => {
                                that.addLoading = false
                                this.$message.error(error)
                            })
                        }
                    })
                }

            },
            upMerchant() {
                let that = this
                that.$refs['editform'].validate((valid) => {
                    if (valid) {
                        console.log(that.editform)
                        let url = that.$apiUrl.merchant.upsubService
                        that.$post(url, that.$params(that.editform)).then(res => {
                            if (res.data.msg == "修改失败" || res.data.msg=='必须有上级'||res.data.msg == "添加失败" ||res.data.msg == "服务费错误" || res.data.msg == "服务商错误" ||res.data.msg =='服务商重复') {
                                this.$message.error(res.data.msg)
                            } else if (res.data.msg == "修改成功") {
                                that.editVisible = false
                                that.getData()
                                this.$message.success("修改成功")
                            }
                        }).catch(error => {
                            this.$message.error(error)
                        })
                    }
                })
            },
            // 编辑操作
            handleEdit(index, row) {
                this.idx = index;
                this.editform = Object.assign({}, row);
                this.editVisible = true;
            },
            // 保存编辑
            saveEdit() {
                this.editVisible = false;
                this.$message.success(`修改第 ${this.idx + 1} 行成功`);
                this.$set(this.tableData, this.idx, this.form);
            },
            // 分页导航
            handlePageChange(val) {
                this.$set(this.query, 'page', val);
                this.getData();
            },
            
        }
    };
</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }
</style>